import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { NavLink } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { Theme } from '../../../../config/theme';

import Dismiss from '-!svg-react-loader!./dismiss.svg'; // eslint-disable-line
import UserImage from '../../../UserImage';

export default class UserMenu extends Component {
  constructor(props) {
    super(props);

    this.readHandler = this.notificationRead.bind(this);
  }

  notificationRead() {
    this.props.handler(this.props.id, this.props.type);
  }

  render() {
    return (
      <li className={css(styles.notification)}>
        {
          this.props.image ? (
            <UserImage styles={styles.notification_image} image={this.props.image} />
          ) : false
        }
        <div className={css(styles.notification_content)}>
          {this.props.children}
          {this.props.profileLink ?
            <NavLink
              onClick={this.readHandler}
              to={this.props.profileLink}
              className={css(styles.notification_view)}
            >
              View profile
            </NavLink>
          : null}
        </div>
        {
          this.props.closable ? (
            <Dismiss
              onClick={this.readHandler}
              className={css(styles.notification_dismiss)} />
          ) : false
        }
      </li>
    );
  }
}

UserMenu.defaultProps = {
  profileLink: null,
  closable: true,
  handler: () => {},
};

UserMenu.propTypes = {
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  handler: PropTypes.func,
  children: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  profileLink: PropTypes.string,
  closable: PropTypes.bool,
};

const styles = StyleSheet.create({
  notification: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: 12,
    cursor: 'default',

    ':not(:last-child)': {
      borderBottom: '1px solid #16345a',
    },
  },

  notification_dismiss: {
    display: 'block',
    flexShrink: 0,
    height: 12,
    width: 12,
    marginTop: 12,
    marginRight: 4,
    cursor: 'pointer',

    ':not(.a) > path': { // Ugly descendant selector trick...
      transition: 'fill 300ms',
    },

    ':hover > path': {
      fill: '#E85E5E',
    },
  },

  notification_image: {
    flexShrink: 0,
    height: 55,
    width: 55,
    marginLeft: 0,
    marginRight: 15,
  },

  notification_content: {
    paddingTop: 10,
    paddingRight: 12,
    paddingBottom: 6,
    fontSize: 15,
    cursor: 'default',
    width: '100%',
  },

  notification_view: {
    display: 'block',
    marginTop: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: 900,
    color: '#39b4d6',
    fontSize: 14,
  },
});



// WEBPACK FOOTER //
// ./src/components/NotificationsMenu/components/Notification/index.js